/*
 * Lalavava Customer Reviews — storefront widget (R1 model).
 * - "Load more": fetches the full reviews JSON from Shopify Files CDN (no ERP read).
 * - Submit form: uploads photos to ERP -> Shopify Files, then POSTs the review (PENDING).
 * Customer-facing copy is ENGLISH. Install as theme asset: lalavava-reviews-widget.js
 */
(function () {
  "use strict";

  function starHtml(rating) {
    var s = "";
    for (var i = 1; i <= 5; i++) {
      s += i <= rating ? "★" : '<span class="lv-star-empty">★</span>';
    }
    return s;
  }

  function esc(str) {
    return String(str == null ? "" : str).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  // ISO date -> "May 24, 2026" (English, customer-facing). Returns "" if unparseable.
  function fmtDate(iso) {
    if (!iso) return "";
    var d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    try {
      return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
    } catch (e) {
      return "";
    }
  }

  // One media item -> <video> for video, <img> (click to open full) otherwise.
  function mediaItemHtml(m) {
    if (!m.url) return "";
    var w = m.w || 600, h = m.h || 600;
    var type = String(m.type == null ? "" : m.type).toLowerCase();
    if (type === "video") {
      var poster = m.thumb ? ' poster="' + esc(m.thumb) + '"' : "";
      return (
        '<video class="lv-review__video" controls preload="metadata"' + poster +
        ' width="' + w + '" height="' + h + '"><source src="' + esc(m.url) + '"></video>'
      );
    }
    return (
      '<img class="lv-review__img" src="' + esc(m.thumb || m.url) + '" data-full="' + esc(m.url) +
      '" width="' + w + '" height="' + h + '" loading="lazy" alt="">'
    );
  }

  // ----- Lightbox (singleton, shared by SSR + Load-more images) -----
  var _lb = null;
  function ensureLightbox() {
    if (_lb) return _lb;
    var box = document.createElement("div");
    box.className = "lv-lightbox";
    box.setAttribute("hidden", "");
    box.innerHTML =
      '<button type="button" class="lv-lightbox__close" aria-label="Close">×</button>' +
      '<img class="lv-lightbox__img" src="" alt="">';
    document.body.appendChild(box);
    function close() { box.setAttribute("hidden", ""); }
    // Backdrop click closes; clicking the image itself does not.
    box.addEventListener("click", function (e) {
      if (e.target === box || e.target.classList.contains("lv-lightbox__close")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !box.hasAttribute("hidden")) close();
    });
    _lb = box;
    return box;
  }
  function openLightbox(src) {
    if (!src) return;
    var box = ensureLightbox();
    box.querySelector(".lv-lightbox__img").src = src;
    box.removeAttribute("hidden");
  }

  function reviewCard(r, shopName) {
    var media = (r.media || []).map(mediaItemHtml).join("");
    var date = fmtDate(r.date);
    var reply = r.reply
      ? '<div class="lv-review__reply"><strong>Reply from ' + esc(shopName) + "</strong><p>" + esc(r.reply) + "</p></div>"
      : "";
    return (
      '<article class="lv-review"><header class="lv-review__head"><strong>' +
      esc(r.author) +
      "</strong>" +
      (r.verified ? '<span class="lv-badge">✓ Verified Buyer</span>' : "") +
      '<span class="lv-review__stars">' + starHtml(r.rating) + "</span></header>" +
      (date ? '<div class="lv-review__date">' + esc(date) + "</div>" : "") +
      (r.body ? '<p class="lv-review__body">' + esc(r.body) + "</p>" : "") +
      (media ? '<div class="lv-review__media">' + media + "</div>" : "") +
      reply +
      "</article>"
    );
  }

  function init(root) {
    var api = root.getAttribute("data-api");
    var shopId = root.getAttribute("data-shop-id");
    var productId = root.getAttribute("data-product-id");
    var fullUrl = root.getAttribute("data-full-url");
    var shopName = (window.Shopify && window.Shopify.shop) || "us";

    // ----- Image lightbox (delegated: covers SSR first screen + Load-more) -----
    root.addEventListener("click", function (e) {
      var img = e.target && e.target.closest ? e.target.closest(".lv-review__img") : null;
      if (img) openLightbox(img.getAttribute("data-full") || img.src);
    });

    // ----- Load more -----
    var moreBtn = root.querySelector("[data-lv-more]");
    var list = root.querySelector("[data-lv-list]");
    if (moreBtn && fullUrl && list) {
      moreBtn.addEventListener("click", function () {
        moreBtn.disabled = true;
        moreBtn.textContent = "Loading…";
        fetch(fullUrl)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            list.innerHTML = (data.reviews || []).map(function (r) { return reviewCard(r, shopName); }).join("");
            moreBtn.style.display = "none";
          })
          .catch(function () {
            moreBtn.disabled = false;
            moreBtn.textContent = "Load more reviews";
          });
      });
    }

    // ----- Rating picker -----
    var form = root.querySelector("[data-lv-review-form]");
    if (!form) return;
    var ratingInput = form.querySelector('input[name="rating"]');
    var picker = root.querySelector("[data-lv-rating]");
    if (picker) {
      var stars = Array.prototype.slice.call(picker.children);
      stars.forEach(function (star, idx) {
        star.addEventListener("click", function () {
          var val = idx + 1;
          ratingInput.value = String(val);
          stars.forEach(function (s, j) { s.className = j < val ? "" : "lv-star-empty"; });
        });
      });
    }

    // Live character counter (280, Twitter-style)
    var bodyEl = form.elements["body"];
    var countEl = root.querySelector("[data-lv-count]");
    if (bodyEl && countEl) {
      bodyEl.addEventListener("input", function () {
        countEl.textContent = bodyEl.value.length + " / 280";
      });
    }

    // Custom upload button: reflect selected files in English (native input is hidden)
    var fileHint = root.querySelector("[data-lv-filehint]");
    var fileInputEl = form.querySelector("[data-lv-files]");
    function refreshFileHint() {
      if (!fileHint || !fileInputEl) return;
      var n = fileInputEl.files ? fileInputEl.files.length : 0;
      fileHint.textContent = n === 0 ? "No file chosen" : (n === 1 ? fileInputEl.files[0].name : n + " files selected");
    }
    if (fileInputEl) fileInputEl.addEventListener("change", refreshFileHint);

    var msg = root.querySelector("[data-lv-msg]");
    function setMsg(text, ok) {
      if (msg) { msg.textContent = text; msg.style.color = ok ? "#15803d" : "#b91c1c"; }
    }

    // ----- Submit -----
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var rating = parseInt(ratingInput.value, 10);
      if (!rating) { setMsg("Please select a rating.", false); return; }

      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      setMsg("Submitting…", true);

      var fileInput = form.querySelector("[data-lv-files]");
      var files = fileInput && fileInput.files ? Array.prototype.slice.call(fileInput.files) : [];

      // Upload photos first -> media tokens
      var uploads = files.map(function (file) {
        var fd = new FormData();
        fd.append("shop_id", shopId);
        fd.append("file", file);
        return fetch(api + "/public/reviews/upload", { method: "POST", body: fd })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { return j ? j.media_token : null; })
          .catch(function () { return null; });
      });

      // form.elements[name] avoids the HTMLFormElement.title property shadowing the "title" input
      function fv(name) {
        var el = form.elements[name];
        return el ? el.value : "";
      }
      Promise.all(uploads).then(function (tokens) {
        var body = {
          shop_id: shopId,
          shopify_product_id: parseInt(productId, 10),
          rating: rating,
          body: fv("body") || null,
          author_name: fv("author_name"),
          author_email: fv("author_email") || null,
          locale: (navigator.language || "").slice(0, 8) || null,
          media_tokens: tokens.filter(Boolean),
          website: fv("website") || null
        };
        return fetch(api + "/public/reviews", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        });
      }).then(function (r) {
        if (r.ok) {
          form.reset();
          if (ratingInput) ratingInput.value = "0";
          refreshFileHint();
          setMsg("Thanks! Your review will appear after moderation.", true);
        } else if (r.status === 409) {
          setMsg("You have already reviewed this product.", false);
        } else if (r.status === 429) {
          setMsg("Too many submissions. Please try again later.", false);
        } else {
          setMsg("Sorry, something went wrong. Please try again.", false);
        }
      }).catch(function () {
        setMsg("Network error. Please try again.", false);
      }).finally(function () {
        submitBtn.disabled = false;
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-lv-reviews]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
